import { cn, TextButton } from '@yanolja-rnd/nol-design-system'
import { getYaNative } from '@yanolja-rnd/ya-native'
import { useCallback } from 'react'
import conf from '~/app/conf'
import { isNative } from '~/app/utils/typeguards'

const CartLogin = ({ className }: { className?: string }) => {
  const onClickLogin = useCallback(async () => {
    const yaNative = getYaNative()
    if (isNative(yaNative)) {
      yaNative.login()
    } else {
      location.href = `${conf.web.url}/login?redirect=${window.location.href}`
    }
  }, [])

  return (
    <div className={cn('flex w-full items-center justify-center gap-8', className)}>
      <div className="text-text-neutral-sub typography-body-13-regular">
        로그인하고 NOL 회원 전용 특가를 확인해 보세요.
      </div>
      <TextButton
        theme="underline"
        weight="bold"
        mobileSize="medium"
        pcSize="medium"
        onClick={onClickLogin}
      >
        로그인하기
      </TextButton>
    </div>
  )
}

export default CartLogin
